module.exports = {"school-name":"College of Southern Idaho","logo":"/sites/csi/logo.svg","logout-color":"#686B6D","logout-font-color":"#fff","header-color":"#000","header-border-color":"#FDC82F","footer-color":"#000","footer-info":"© 2020 College of Southern Idaho | The Write Class™ | © 2020 Boise State University","help-button-color":"#686B6D","help-button-font-color":"#FFFFFF"}


//////////////////
// WEBPACK FOOTER
// ./sites/csi/site-config.json
// module id = 116
// module chunks = 12